import request from "@/router/axios";

// 获取我的签批列表
export const normalFlowablePage = (current, size, params, search) => {
    return request({
      url: `/api/blade-businessNormalFlowable/businessNormalFlowable/normal-flowable-page`,
      method: "post",
      data: {
        current,
        size,
        ...params,
        ...search,
      },
    });
  }

  export const normalFlowableDetail = (id) => {
    return request({
      url: `/api/blade-businessNormalFlowable/businessNormalFlowable/normal-flowable-detail`,
      method: "get",
      params: {
        id
      },
    });
  }

  // 我的签批审核通过
export const normalFlowableAudit = (params) => {
  return request({
    url: `/api/blade-businessNormalFlowable/businessNormalFlowable/normal-flowable-audit`,
    method: "post",
    data: params
  });
}

// 查看资料清单
export const mailDataGet = (mailBusinessNormalFlowableId) => {
  return request({
    url: `/api/blade-loanHaveBeenMailed/loanHaveBeenMailed/mailDataGet/${mailBusinessNormalFlowableId}`,
    method: "get",
  });
}

// 查看资料清单 没有流程的
export const mailDataGetAll = (loanInformationId) => {
  return request({
    url: `/api/blade-loanHaveBeenMailed/loanHaveBeenMailed/mailDataGetAll/${loanInformationId}`,
    method: "get",
  });
}

// 查看借阅清单
export const borrowkeycerfiticate = (flowId) => {
  return request({
    url: `/api/blade-borrowkeycerfiticate/borrowkeycerfiticate/detail`,
    method: "get",
    params: {
      flowId
    }
  });
}

// 投诉结清签批
export const complaintSettlementAudit = (params) => {
  return request({
    url: `/api/blade-businessNormalFlowable/businessNormalFlowable/complaint-settlement-flowable-audit`,
    method: "post",
    data: params
  });
}